import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Navbar, { MobileBottomBar } from "@/components/Navbar";
import { Footer } from "@/components/Contact";
import { Reveal } from "@/components/Reveal";
import { api, imgSrc } from "@/lib/api";
import { useContent } from "@/App";

export default function Blog() {
  const content = useContent();
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <main className="min-h-screen" data-testid="blog-page">
      <SEO title={content?.seo?.blog_title} description={content?.seo?.blog_description} image={content?.seo?.og_image} path="/blog" />
      <Navbar />
      <div className="mx-auto max-w-7xl px-4 pb-20 pt-32 sm:px-8 lg:px-16 lg:pt-40">
        <Reveal>
          <p className="eyebrow mb-4">The Journal</p>
          <h1 className="max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-cream sm:text-5xl">
            Notes from the <span className="italic text-copper-gradient">Karwar coast.</span>
          </h1>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(posts || []).map((p, i) => (
            <Reveal key={p.id} delay={0.06 * (i % 3)}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="card-hover group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-charcoal-800">
                {p.cover_image && (
                  <div className="overflow-hidden">
                    <img src={imgSrc(p.cover_image)} alt={p.title} loading="lazy"
                      className="aspect-[16/10] w-full object-cover transition-transform duration-[1.3s] ease-out group-hover:scale-105" />
                  </div>
                )}
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex gap-2">
                    {(p.tags || []).map((t) => <span key={t} className="text-[10px] font-mono uppercase tracking-[0.2em] text-copper-400">{t}</span>)}
                  </div>
                  <h2 className="mt-3 font-serif text-xl text-cream transition-colors group-hover:text-copper-300">{p.title}</h2>
                  <p className="mt-2 flex-1 text-sm font-light leading-relaxed text-cream-muted">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.15em] text-copper-300">
                    Read guide <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        {posts && posts.length === 0 && <p className="mt-10 text-cream-muted">Guides are being written — check back soon.</p>}
      </div>
      <Footer settings={content?.settings} />
      <MobileBottomBar />
    </main>
  );
}
